<script setup lang="ts">

import router from '@/router'
import { RouteName } from '@/routes'
import BaseLinkButton from '@/components/base/BaseLinkButton.vue'
import { T } from '@tolgee/vue'
import { useBadges } from '@/composables/game/badge'
import { computed, onBeforeMount } from 'vue'

const { badgesWithCount, getBadges } = useBadges()

const badgesWithCountToShow = computed(() =>
  badgesWithCount.value
    .filter((item) => item.count)
    .sort((a, b) => a.badge.order - b.badge.order),
)

onBeforeMount(() => getBadges())
</script>

<template>
  <div
    v-if="badgesWithCountToShow.length"
    class="flex flex-col gap-y-3"
  >
    <div
      v-for="badgeWithCount in badgesWithCountToShow"
      :key="badgeWithCount.badge.id"
      class="rounded-2xl flex items-center justify-between gap-x-2 p-2 pr-4 bg-dark-bottom-layer w-full min-w-0"
    >
      <div class="flex items-center gap-x-3.5">
        <div class="rounded-full w-12 h-12 min-w-[48px] p-[3px] overflow-hidden relative">
          <div
            class="bg-dark-primary/80 rounded-full w-full h-full flex items-center justify-center"
          >
            <img
              :src="badgeWithCount.badge.imageUrl"
              class="object-cover rounded-full scale-in w-12 h-12 min-w-[48px]"
            >
          </div>
        </div>
        <div class="flex-1 line-clamp-2 text-base font-semibold -tracking-[0.32px]">
          {{ badgeWithCount.badge.name }}
        </div>
      </div>
      <div
        v-if="badgeWithCount.showCount"
        class="gray-border rounded-[38.8px] p-[1.3px]"
      >
        <div
          class="text-sm leading-[14px] font-semibold text-white/[87%] py-1 px-1.5 bg-tropee-black rounded-[38.8px]"
        >
          {{ badgeWithCount.count }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="rounded-xl flex flex-col items-center p-2 bg-dark-bottom-layer"
  >
    <div class="text-center text-white/70 text-base font-medium">
      <T
        key-name="badges.empty_state_title"
        default-value="You do not have any badges yet!"
      />
      <BaseLinkButton
        class="mx-auto"
        @click="router.push({name: RouteName.MINE})"
      >
        <T
          key-name="badges.empty_state_button"
          default-value="Get your first badge here"
        />
      </BaseLinkButton>
    </div>
  </div>
</template>
<style scoped>
.gray-border {
	background: linear-gradient(rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.4) 100%);
}
</style>